/**
 * Norativ Elite PDP v14 - CLEAN REWRITE
 * Gallery · Size · Packs · Colour carousel · Slots · Cart · Upsells
 */
(function () {
  'use strict';

  /**
   * @param {HTMLElement} root
   */
  function init(root) {
    if (!root) return;
    const sid = root.id;

    /* ── Config ── */
    const r_any = (/** @type {any} */(root));
    const BUNDLE_LIMIT = parseInt(r_any.dataset.bundleQty, 10) || 6;
    const SINGLE_LIMIT = parseInt(r_any.dataset.singleQty, 10) || 1;
    const CTA_BUNDLE   = r_any.dataset.ctaBundle || 'Add to cart';
    const CTA_SINGLE   = r_any.dataset.ctaSingle || 'Add to cart';
    const CTA_WAIT     = r_any.dataset.ctaWait   || 'Select items';

    /* ── State ── */
    /** @type {{ size: string|null, limit: number, mode: string, slots: any[], loading: boolean }} */
    const S = { size: null, limit: BUNDLE_LIMIT, mode: 'bundle', slots: [], loading: false };

    /* ── Helpers ── */
    const q  = (/** @type {string} **/ sel) => (/** @type {any} */(root.querySelector(sel)));
    const qa = (/** @type {string} **/ sel) => Array.from(root.querySelectorAll(sel));

    /* ── Cart Drawer Helper ── */
    function openCart() {
      const upc = (/** @type {any} */(window)).upcart;
      if (upc && typeof upc.open === 'function') {
        try { upc.open(); return; } catch (e) {}
      }
      if (upc && typeof upc.openDrawer === 'function') {
        try { upc.openDrawer(); return; } catch (e) {}
      }
      ['upcart:open','upcart:added','cart:open','theme:cart:open','PXUTheme:cartDrawer:open'].forEach(ev => {
        document.dispatchEvent(new CustomEvent(ev, { bubbles: true }));
      });
      const btn = document.querySelector('[data-upcart-open], .cart-count-bubble');
      if (btn) (/** @type {HTMLElement} */(btn)).click();
    }

    /* ── DOM ── */
    const track     = q('.pdp-gallery__track');
    const dots      = qa('.pdp-dot');
    const packBtns  = qa('.pdp-pack');
    const szBtns    = qa('.pdp-sz');
    const szVal     = q('.js-size-val');
    const colCards  = qa('.pdp-col-card');
    const segsWrap  = q('.pdp-segs');
    const slotsWrap = q('.js-slots');
    const counter   = q('.js-counter');
    const ctaBtns   = qa('.js-cta');
    const priceEl   = q('.js-price');
    const stickyBar = q('.js-sticky-bar');
    const colourRow = q('.js-colour-row');

    /* ── Variant map ── */
    const vm = new Map();
    colCards.forEach(c => {
      const c_any = (/** @type {any} */(c));
      try { vm.set(c_any.dataset.handle, JSON.parse(c_any.dataset.variants)); } catch (_) {}
    });

    /* ── Gallery ── */
    let curSlide = 0;
    function goSlide(/** @type {number} */ i) {
      const g_slides = track ? track.querySelectorAll('.pdp-gallery__slide') : [];
      curSlide = Math.max(0, Math.min(i, g_slides.length - 1));
      dots.forEach((d, j) => (/** @type {HTMLElement} */(d)).classList.toggle('is-active', j === curSlide));
      if (track) track.scrollTo({ left: track.offsetWidth * curSlide, behavior: 'smooth' });
    }
    dots.forEach((d, i) => d.addEventListener('click', () => goSlide(i)));
    if (track) {
      track.addEventListener('scroll', () => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== curSlide) {
          curSlide = i;
          dots.forEach((d, j) => (/** @type {HTMLElement} */(d)).classList.toggle('is-active', j === curSlide));
        }
      }, { passive: true });
    }

    /* ── Pack Buttons ── */
    packBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const b = (/** @type {HTMLElement} */(btn));
        packBtns.forEach(p => p.classList.remove('is-active'));
        b.classList.add('is-active');
        S.mode  = b.dataset.mode || 'bundle';
        S.limit = parseInt(b.dataset.limit || '1', 10);
        if (priceEl && b.dataset.price) priceEl.textContent = b.dataset.price;
        if (S.slots.length > S.limit) S.slots = S.slots.slice(0, S.limit);
        rebuildSegs(); rebuildSlots(); renderCTA(); renderBadges();
      });
    });

    /* ── Size ── */
    /** @param {string} sz */
    function selectSize(sz) {
      if (!sz) return;
      S.size = sz;
      if (szVal) szVal.textContent = sz;
      szBtns.forEach(b => {
        const b_el = (/** @type {HTMLElement} */(b));
        b_el.classList.toggle('is-active', b_el.dataset.size === sz);
      });
      checkAvail();
    }
    szBtns.forEach(b => {
      b.addEventListener('click', () => {
        const b_el = (/** @type {HTMLElement} */(b));
        selectSize(b_el.dataset.size || '');
      });
    });
    const initBtn = szBtns.find(b => b.classList.contains('is-active'));
    if (initBtn) selectSize((/** @type {any} */(initBtn)).dataset.size);

    /* ── Availability ── */
    /** @param {string} handle */
    function findVariant(handle) {
      const list = vm.get(handle);
      if (!list || !S.size) return null;
      const sz = S.size.toUpperCase().trim();
      return list.find((/** @type {any} */ v) => {
        const v_any = (/** @type {any} */(v));
        return (v_any.option1 && v_any.option1.toUpperCase() === sz) ||
               (v_any.option2 && v_any.option2.toUpperCase() === sz) ||
               (v_any.option3 && v_any.option3.toUpperCase() === sz) ||
               (v_any.title && v_any.title.toUpperCase().includes(sz));
      }) || null;
    }
    function checkAvail() {
      colCards.forEach(c => {
        const c_el = (/** @type {HTMLElement} */(c));
        const v = findVariant(c_el.dataset.handle || '');
        const ok = !!(v && v.available);
        c_el.classList.toggle('is-disabled', !ok);
        const b = (/** @type {HTMLButtonElement | null} */(c_el.querySelector('.pdp-col-card__btn')));
        if (b) b.disabled = !ok;
      });
    }

    /* ── Slots ── */
    /** @param {any} item */
    function addSlot(item) {
      if (S.slots.length >= S.limit) {
        if (slotsWrap) slotsWrap.classList.add('pdp-shake');
        setTimeout(() => slotsWrap && slotsWrap.classList.remove('pdp-shake'), 430);
        return;
      }
      S.slots.push(item);
      rebuildSegs(); rebuildSlots(); renderCTA(); renderBadges();
    }
    /** @param {number} i */
    function removeSlot(i) {
      S.slots.splice(i, 1);
      rebuildSegs(); rebuildSlots(); renderCTA(); renderBadges();
    }

    /* ── Rendering ── */
    function rebuildSegs() {
      if (!segsWrap) return;
      segsWrap.innerHTML = '';
      for (let i = 0; i < S.limit; i++) {
        const d = document.createElement('div');
        d.className = 'pdp-seg' + (i < S.slots.length ? ' is-filled' : '');
        segsWrap.appendChild(d);
      }
    }
    function rebuildSlots() {
      if (!slotsWrap) return;
      slotsWrap.innerHTML = '';
      for (let i = 0; i < S.limit; i++) {
        const itemWrap = document.createElement('div');
        itemWrap.className = 'pdp-slot-item';

        const d = document.createElement('div');
        const filled = i < S.slots.length;
        d.className = 'pdp-slot ' + (filled ? 'is-filled' : 'is-empty');

        if (filled) {
          const item = S.slots[i];
          d.innerHTML = `<img src="${item.img}" alt="${item.title}">`;
          
          const rmBtn = document.createElement('button');
          rmBtn.className = 'pdp-slot__rm-row';
          rmBtn.innerHTML = 'Remove';
          rmBtn.addEventListener('click', (e) => { 
            e.stopPropagation(); 
            removeSlot(i); 
          });

          itemWrap.appendChild(d);
          itemWrap.appendChild(rmBtn);
        } else {
          d.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';
          itemWrap.appendChild(d);
        }
        slotsWrap.appendChild(itemWrap);
      }
      if (counter) {
        const rem = S.limit - S.slots.length;
        counter.textContent = rem > 0 ? `${rem} items to go` : '✓ Bundle ready!';
      }
    }
    function renderCTA() {
      if (!ctaBtns.length) return;
      const full = S.slots.length >= S.limit;
      ctaBtns.forEach(btn => {
        const cta = (/** @type {HTMLButtonElement} */(btn));
        // Sticky CTA is never truly disabled — it scrolls to colours when not full
        if (cta.classList.contains('js-sticky-cta')) {
          cta.disabled = false;
          cta.classList.toggle('is-ready', full);
        } else {
          cta.disabled = !full;
          cta.classList.toggle('is-ready', full);
        }
        if (full) {
          cta.textContent = S.mode === 'bundle' ? CTA_BUNDLE : CTA_SINGLE;
        } else {
          const rem = S.limit - S.slots.length;
          cta.textContent = rem === S.limit ? '↑ Pick your colours' : `↑ Select ${rem} more`;
        }
      });
    }
    function renderBadges() {
      colCards.forEach(c => {
        const c_el = (/** @type {HTMLElement} */(c));
        const cnt = S.slots.filter((/** @type {any} */ s) => s.handle === c_el.dataset.handle).length;
        const qel = (/** @type {HTMLElement | null} */(c_el.querySelector('.js-qty')));
        if (qel) { qel.textContent = cnt + 'x'; qel.style.display = cnt > 0 ? '' : 'none'; }
        c.classList.toggle('is-selected', cnt > 0);
      });
    }

    /* ── Add to Cart Events ── */
    colCards.forEach(c => {
      const c_el = (/** @type {HTMLElement} */(c));
      const btn = (/** @type {HTMLButtonElement|null} */(c_el.querySelector('.js-add')));
      if (btn) btn.addEventListener('click', () => {
        const v = findVariant(c_el.dataset.handle || '');
        if (v && v.available) {
          addSlot({ id: v.id, handle: c_el.dataset.handle, title: c_el.dataset.title, img: c_el.dataset.img });
        }
      });
    });

    /* ── Scroll-to-colours helper ── */
    function scrollToColours() {
      const target = colourRow || q('.pdp-carousel');
      if (!target) return;
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      // Pulse animation to draw attention
      target.classList.add('pdp-pulse');
      setTimeout(() => target.classList.remove('pdp-pulse'), 1200);
    }

    async function addToCart() {
      // If bundle not full, scroll to colours instead of blocking
      if (S.slots.length < S.limit) {
        scrollToColours();
        return;
      }
      if (S.loading) return;
      S.loading = true;
      const prev = ctaBtns[0].textContent;
      ctaBtns.forEach(btn => btn.textContent = 'Adding...');
      try {
        const grouped = {};
        S.slots.forEach(s => {
          grouped[s.id] = (grouped[s.id] || 0) + 1;
        });
        const itemsPayload = Object.keys(grouped).map(vid => ({ id: parseInt(vid, 10), quantity: grouped[vid] }));

        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: itemsPayload }),
        });
        if (!res.ok) throw new Error('Cart error');
        const cartData = await res.json();
        ctaBtns.forEach(btn => btn.textContent = '✓ Added!');

        // ────────────────────────────────────────────────────────
        // Native Shopify Analytics hook
        try {
          if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
            window.Shopify.analytics.publish("product_added_to_cart", { cart: cartData });
          } else if (window.ShopifyAnalytics && window.ShopifyAnalytics.lib) {
            window.ShopifyAnalytics.lib.track('Added product');
          }
        } catch(e) {}

        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        
        // Go to cart instead of checkout
        setTimeout(() => openCart(), 500);
      } catch (err) {
        alert('Error: ' + err.message);
        ctaBtns.forEach(btn => btn.textContent = prev);
      } finally { S.loading = false; }
    }
    ctaBtns.forEach(btn => btn.addEventListener('click', addToCart));

    /* ── Sticky Bar Observer ── */
    if (stickyBar && ctaBtns.length > 0) {
      const mainCta = ctaBtns[0];
      const obs = new IntersectionObserver((entries) => {
        entries.forEach(e => {
          if (!e.isIntersecting && e.boundingClientRect.top < 0) {
            stickyBar.classList.add('is-visible');
          } else {
            stickyBar.classList.remove('is-visible');
          }
        });
      }, { threshold: 0 });
      obs.observe(mainCta);
    }

    /* ── Upsells (Popular Packs) ── */
    qa('.js-upsell').forEach(card => {
      const c_any = (/** @type {any} */(card));
      const h = c_any.dataset.handle;
      const szs = card.querySelectorAll('.js-upsell-sz');
      const atc = card.querySelector('.js-upsell-atc');
      /** @type {any[]} */
      let variants = [];
      let selSz = 'L';
      const active = Array.from(szs).find(b => b.classList.contains('is-active'));
      if (active) selSz = (/** @type {any} */(active)).dataset.size || 'L';

      (async () => {
        try { const r = await fetch(`/products/${h}.js`); const p = await r.json(); variants = p.variants; } catch (e) {}
      })();

      szs.forEach(b => b.addEventListener('click', (e) => {
        e.preventDefault(); e.stopPropagation();
        const b_el = (/** @type {any} */(b));
        selSz = b_el.dataset.size;
        szs.forEach(el => el.classList.toggle('is-active', el === b));
      }));

      if (atc) atc.addEventListener('click', async () => {
        if (!variants.length) {
          try { const r = await fetch(`/products/${h}.js`); const p = await r.json(); variants = p.variants; } catch (e) {}
        }
        const sz = selSz.toUpperCase().trim();
        const v = variants.find((/** @type {any} */ variant) => {
          const v_any = (/** @type {any} */(variant));
          return (v_any.option1 && v_any.option1.toUpperCase() === sz) ||
                 (v_any.option2 && v_any.option2.toUpperCase() === sz) ||
                 (v_any.option3 && v_any.option3.toUpperCase() === sz) ||
                 (v_any.title && v_any.title.toUpperCase().includes(sz)) ||
                 (v_any.options && Array.isArray(v_any.options) && v_any.options.map((/** @type {string} */ o) => o.toUpperCase()).includes(sz));
        });
        if (!v) { alert('Size unavailable'); return; }
        const atcBtn = (/** @type {HTMLButtonElement} */(atc));
        atcBtn.disabled = true; const ot = atc.textContent; atc.textContent = 'Adding...';
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
          });
          if (!res.ok) throw new Error();
          const cartData = await res.json();
          atc.textContent = '✓ Added!';

          // ── Shopify Analytics & Apps: AddToCart ───────────────────────
          try {
            if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
              window.Shopify.analytics.publish("product_added_to_cart", { cart: cartData });
            } else if (window.ShopifyAnalytics && window.ShopifyAnalytics.lib) {
              window.ShopifyAnalytics.lib.track('Added product');
            }

            // --- Meta Pixel: Consolidated AddToCart & Lock ---
            window._fbqLastFire = window._fbqLastFire || {};
            var now = Date.now();
            if (!(window._fbqLastFire[v.id] && (now - window._fbqLastFire[v.id] < 2000))) {
              window._fbqLastFire[v.id] = now;
              if (typeof window.fbq === 'function') {
                window.fbq('track', 'AddToCart', {
                  content_type: 'product',
                  content_ids: [String(v.id)],
                  num_items: 1,
                  currency: (window.Shopify && window.Shopify.currency) ? window.Shopify.currency.active : 'EUR'
                });
              }
            }
            // -------------------------------------------------

            // Universal event for apps like Clarity and UpCart
            document.dispatchEvent(new CustomEvent('cart:add', { 
              bubbles: true,
              detail: { variant_id: v.id, quantity: 1 }
            }));
            // Notify Shopify of the cart change
            if (window.Shopify && window.Shopify.onItemAdded) {
              window.Shopify.onItemAdded();
            }
          } catch(e) {}
          // ─────────────────────────────────────────────────────────────

          // ────────────────────────────────────────────────────


          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          const upc = (/** @type {any} */(window)).upcart;
          if (upc && upc.openDrawer) upc.openDrawer();
          setTimeout(() => { atc.textContent = ot; atcBtn.disabled = false; }, 2000);
        } catch (e) { alert('Error adding upsell'); atc.textContent = ot; atcBtn.disabled = false; }
      });
    });

    /* ── Size Guide Modal ── */
    const sgOpen = q('.js-sg-open');
    const sgClose = qa('.js-sg-close');
    const sgOverlay = q('.pdp-sg-overlay');
    const sgModal = q('.pdp-sg-modal');

    function toggleSG(show) {
      if (!sgOverlay || !sgModal) return;
      sgOverlay.classList.toggle('is-open', show);
      sgModal.classList.toggle('is-open', show);
      document.body.style.overflow = show ? 'hidden' : '';
    }

    if (sgOpen) sgOpen.addEventListener('click', () => toggleSG(true));
    sgClose.forEach(b => b.addEventListener('click', () => toggleSG(false)));

    /* ── Size Calculator (Isolated) ── */
    (function initSizeCalculator() {
      if (!sgOpen) return;

      // 1. Create and inject Trigger Button
      const calcBtn = document.createElement('button');
      calcBtn.className = 'pdp-calc-trigger';
      calcBtn.type = 'button';
      calcBtn.textContent = 'Calculate My Size';

      // 2. Wrap both buttons to keep them together on the right
      const btnWrap = document.createElement('div');
      btnWrap.className = 'pdp-calc-btn-wrap';
      sgOpen.parentNode.insertBefore(btnWrap, sgOpen);
      btnWrap.appendChild(sgOpen);
      btnWrap.appendChild(calcBtn);

      // 3. Create and inject Modal (if not already there)
      let overlay = document.querySelector('.pdp-calc-overlay');
      if (!overlay) {
        overlay = document.createElement('div');
        overlay.className = 'pdp-calc-overlay';
        overlay.innerHTML = `
          <div class="pdp-calc-modal">
            <button class="pdp-calc-close" type="button">&times;</button>
            <div class="pdp-calc-screen-1">
              <h2 class="pdp-calc-title">Calculate My Size</h2>
              <div class="pdp-calc-toggle-wrap">
                <button class="pdp-calc-toggle-btn is-active" type="button" data-unit="imp">Imperial</button>
                <button class="pdp-calc-toggle-btn" type="button" data-unit="met">Metric</button>
              </div>
              
              <div class="pdp-calc-group">
                <!-- Imperial Fields -->
                <div class="pdp-calc-unit-block js-calc-imp-block" style="display:block">
                  <div class="pdp-calc-row" style="margin-bottom:18px">
                    <label class="pdp-calc-label">Height</label>
                    <div class="pdp-calc-input-row" style="display:flex">
                      <div class="pdp-calc-field">
                        <input type="number" class="pdp-calc-input js-calc-ft">
                        <span class="pdp-calc-unit-label">ft</span>
                      </div>
                      <div class="pdp-calc-field">
                        <input type="number" class="pdp-calc-input js-calc-in">
                        <span class="pdp-calc-unit-label">in</span>
                      </div>
                    </div>
                  </div>
                  <div class="pdp-calc-row">
                    <label class="pdp-calc-label">Weight</label>
                    <div class="pdp-calc-field">
                      <input type="number" class="pdp-calc-input js-calc-lbs">
                      <span class="pdp-calc-unit-label">lbs</span>
                    </div>
                  </div>
                </div>

                <!-- Metric Fields -->
                <div class="pdp-calc-unit-block js-calc-met-block" style="display:none">
                  <div class="pdp-calc-row" style="margin-bottom:18px">
                    <label class="pdp-calc-label">Height</label>
                    <div class="pdp-calc-field">
                      <input type="number" class="pdp-calc-input js-calc-cm">
                      <span class="pdp-calc-unit-label">cm</span>
                    </div>
                  </div>
                  <div class="pdp-calc-row">
                    <label class="pdp-calc-label">Weight</label>
                    <div class="pdp-calc-field">
                      <input type="number" class="pdp-calc-input js-calc-kg">
                      <span class="pdp-calc-unit-label">kg</span>
                    </div>
                  </div>
                </div>
              </div>

              <button class="pdp-calc-submit js-calc-see" type="button">See my size</button>
            </div>
            <div class="pdp-calc-screen-2" style="display:none">
              <div class="pdp-calc-result-screen">
                <div class="pdp-calc-result-label">We recommend you order</div>
                <div class="pdp-calc-result-size js-calc-result">L</div>
                <div class="pdp-calc-result-social">
                  <strong class="js-calc-count">5,102</strong> customers with similar measurements chose this size
                </div>
                <button class="pdp-calc-submit js-calc-back" type="button">Back to product page</button>
              </div>
            </div>
          </div>
        `;
        document.body.appendChild(overlay);
      }

      // 4. Logic
      const closeBtn = overlay.querySelector('.pdp-calc-close');
      const toggleBtns = overlay.querySelectorAll('.pdp-calc-toggle-btn');
      const seeBtn = overlay.querySelector('.js-calc-see');
      const backBtn = overlay.querySelector('.js-calc-back');
      const screen1 = overlay.querySelector('.pdp-calc-screen-1');
      const screen2 = overlay.querySelector('.pdp-calc-screen-2');
      const resultSize = overlay.querySelector('.js-calc-result');
      const resultCount = overlay.querySelector('.js-calc-count');
      const impBlock = overlay.querySelector('.js-calc-imp-block');
      const metBlock = overlay.querySelector('.js-calc-met-block');

      let currentUnit = 'imp';

      const toggleModal = (show) => {
        overlay.classList.toggle('is-active', show);
        document.body.style.overflow = show ? 'hidden' : '';
        if (!show) {
          setTimeout(() => {
            (/** @type {any} */(screen1)).style.display = 'block';
            (/** @type {any} */(screen2)).style.display = 'none';
          }, 300);
        }
      };

      calcBtn.addEventListener('click', (e) => { e.preventDefault(); toggleModal(true); });
      closeBtn.addEventListener('click', () => toggleModal(false));
      overlay.addEventListener('click', (e) => { if (e.target === overlay) toggleModal(false); });

      toggleBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          currentUnit = (/** @type {any} */(btn)).dataset.unit;
          toggleBtns.forEach(b => b.classList.toggle('is-active', b === btn));
          (/** @type {any} */(impBlock)).style.display = currentUnit === 'imp' ? 'block' : 'none';
          (/** @type {any} */(metBlock)).style.display = currentUnit === 'met' ? 'block' : 'none';
        });
      });

      seeBtn.addEventListener('click', () => {
        overlay.querySelectorAll('.pdp-calc-error').forEach(e => e.remove());
        let valid = true;
        const inputs = currentUnit === 'imp' ? ['.js-calc-ft', '.js-calc-in', '.js-calc-lbs'] : ['.js-calc-cm', '.js-calc-kg'];
        
        inputs.forEach(sel => {
          const el = (/** @type {HTMLInputElement} */(overlay.querySelector(sel)));
          if (!el.value || isNaN(parseFloat(el.value))) {
            const err = document.createElement('div');
            err.className = 'pdp-calc-error';
            err.textContent = 'Required';
            (/** @type {any} */(el.parentNode)).appendChild(err);
            valid = false;
          }
        });

        if (!valid) return;

        let ft, in_, lbs;
        if (currentUnit === 'imp') {
          ft = parseFloat((/** @type {HTMLInputElement} */(overlay.querySelector('.js-calc-ft'))).value);
          in_ = parseFloat((/** @type {HTMLInputElement} */(overlay.querySelector('.js-calc-in'))).value);
          lbs = parseFloat((/** @type {HTMLInputElement} */(overlay.querySelector('.js-calc-lbs'))).value);
        } else {
          const cm = parseFloat((/** @type {HTMLInputElement} */(overlay.querySelector('.js-calc-cm'))).value);
          const kg = parseFloat((/** @type {HTMLInputElement} */(overlay.querySelector('.js-calc-kg'))).value);
          const totalInches = cm / 2.54;
          ft = Math.floor(totalInches / 12);
          in_ = totalInches % 12;
          lbs = kg * 2.20462;
        }

        const h = Math.round(ft * 12 + in_);
        let size = "L"; 
        
        if (h <= 67) { 
          size = lbs < 150.5 ? "S" : "M";
        } else if (h >= 68 && h <= 72) { 
          if (lbs < 150.5) size = "S";
          else if (lbs < 185.5) size = "M";
          else if (lbs < 210.5) size = "L";
          else if (lbs < 250.5) size = "XL";
          else if (lbs < 285.5) size = "2XL";
          else size = "3XL";
        } else if (h === 73 || h === 74) { 
          if (lbs < 185.5) size = "M";
          else if (lbs < 210.5) size = "L";
          else if (lbs < 250.5) size = "XL";
          else if (lbs < 285.5) size = "2XL";
          else size = "3XL";
        } else if (h >= 75) { 
          if (lbs < 210.5) size = "L";
          else if (lbs < 250.5) size = "XL";
          else if (lbs < 285.5) size = "2XL";
          else size = "3XL";
        }

        const counts = { "S": "1,245", "M": "4,892", "L": "5,102", "XL": "3,411", "2XL": "1,894", "3XL": "943" };
        
        resultSize.textContent = size;
        resultCount.textContent = (/** @type {any} */(counts))[size] || "1,000+";
        (/** @type {any} */(screen1)).style.display = 'none';
        (/** @type {any} */(screen2)).style.display = 'block';
      });

      backBtn.addEventListener('click', () => toggleModal(false));
    })();

    /* ── Initial render ── */
    try { 
      rebuildSegs(); 
      rebuildSlots(); 
      renderCTA(); 
      checkAvail();
    } catch (e) {
      console.error('[Elite PDP] Render failed', e);
    }
  }

  function boot() { 
    document.querySelectorAll('.pdp').forEach(node => init((/** @type {HTMLElement} */(node)))); 
  }

  if (document.readyState === 'loading') { 
    document.addEventListener('DOMContentLoaded', boot); 
  } else { 
    boot(); 
  }

  document.addEventListener('shopify:section:load', e => {
    const r = (/** @type {HTMLElement} */(e.target)).querySelector('.pdp');
    if (r) init((/** @type {HTMLElement} */(r)));
  });

  /* ── Social Proof Popup ── */
  (function socialProof() {
    const p = (/** @type {HTMLElement|null} */(document.querySelector('.pdp-proof-popup')));
    if (!p) return;
    const nEl = p.querySelector('.js-proof-name');
    const cEl = p.querySelector('.js-proof-city');
    const clBtn = p.querySelector('.js-proof-close');
    if (!nEl || !cEl || !clBtn) return;

    const names = (p.dataset.names || '').split(/[\n\r]+/).map(s => s.trim()).filter(Boolean);
    const cities = (p.dataset.cities || '').split(/[\n\r]+/).map(s => s.trim()).filter(Boolean);
    
    function show() {
      if (nEl) nEl.textContent = names[Math.floor(Math.random() * names.length)];
      if (cEl) cEl.textContent = cities[Math.floor(Math.random() * cities.length)];
      if (p) {
        p.hidden = false;
        setTimeout(() => { 
          p.hidden = true; 
          setTimeout(show, 12000 + Math.random() * 8000); 
        }, 4500);
      }
    }
    
    setTimeout(show, 4000);
    clBtn.addEventListener('click', () => { p.hidden = true; });
  })();

  /* ── Live Stock Bar ── */
  (function stockBar() {
    const f = (/** @type {HTMLElement|null} */(document.querySelector('.js-stock-fill')));
    if (!f) return;
    let p = 15;
    setInterval(() => { 
      if (p > 8) { 
        p -= 0.2; 
        f.style.width = p + '%'; 
      } 
    }, 3000);
  })();

  /* ── Testimonial Carousel ── */
  (function testimonials() {
    const wrap = document.querySelector('.pdp-testimonials');
    if (!wrap) return;
    const slides = wrap.querySelectorAll('.pdp-testi-slide');
    const dotsWrap = wrap.querySelector('.pdp-testi-dots');
    if (slides.length < 2) return;

    let cur = 0;
    let timer = null;

    // Build dots
    if (dotsWrap) {
      slides.forEach((_, i) => {
        const d = document.createElement('button');
        d.className = 'pdp-testi-dot' + (i === 0 ? ' is-active' : '');
        d.addEventListener('click', () => goTo(i));
        dotsWrap.appendChild(d);
      });
    }

    function goTo(i) {
      slides[cur].classList.remove('is-active');
      const dots = dotsWrap ? dotsWrap.querySelectorAll('.pdp-testi-dot') : [];
      if (dots[cur]) dots[cur].classList.remove('is-active');
      cur = i % slides.length;
      slides[cur].classList.add('is-active');
      if (dots[cur]) dots[cur].classList.add('is-active');
      resetTimer();
    }

    function next() { goTo(cur + 1); }
    function resetTimer() { clearInterval(timer); timer = setInterval(next, 6000); }
    resetTimer();
  })();

  /* ── FAQ Accordion ── */
  (function faqAccordion() {
    document.querySelectorAll('.pdp-faq-item').forEach(item => {
      const trigger = item.querySelector('.pdp-faq-q');
      const answer = item.querySelector('.pdp-faq-a');
      if (!trigger || !answer) return;
      trigger.addEventListener('click', () => {
        const open = item.classList.toggle('is-open');
        answer.style.maxHeight = open ? answer.scrollHeight + 'px' : '0';
      });
    });
  })();

  /* ── Gallery Thumbnail Strip (desktop) ── */
  (function thumbStrip() {
    const thumbs = document.querySelectorAll('.pdp-thumb');
    const track = document.querySelector('.pdp-gallery__track');
    if (!thumbs.length || !track) return;
    thumbs.forEach((t, i) => {
      t.addEventListener('click', () => {
        track.scrollTo({ left: track.offsetWidth * i, behavior: 'smooth' });
        thumbs.forEach(th => th.classList.remove('is-active'));
        t.classList.add('is-active');
      });
    });
    // Sync thumbs with swipe
    track.addEventListener('scroll', () => {
      const idx = Math.round(track.scrollLeft / track.clientWidth);
      thumbs.forEach((th, j) => th.classList.toggle('is-active', j === idx));
    }, { passive: true });
  })();

  /* ── HowTo Tabs ── */
  (function howtoTabs() {
    const tabs = document.querySelectorAll('.pdp-howto__tab');
    if (!tabs.length) return;
    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const targetId = tab.getAttribute('data-target');
        const panels = document.querySelectorAll('.pdp-howto__panel');
        // Reset
        tabs.forEach(t => t.classList.remove('is-active'));
        panels.forEach(p => p.classList.remove('is-active'));
        // Activate target
        tab.classList.add('is-active');
        const panel = document.getElementById(targetId);
        if (panel) panel.classList.add('is-active');
      });
    });
  })();

  /* ── Gallery Arrows (desktop) ── */
  (function galleryArrows() {
    const track = document.querySelector('.pdp-gallery__track');
    const prev = document.querySelector('.pdp-gallery__arrow--prev');
    const next = document.querySelector('.pdp-gallery__arrow--next');
    if (!track || !prev || !next) return;
    
    prev.addEventListener('click', () => {
      track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' });
    });
    next.addEventListener('click', () => {
      track.scrollBy({ left: track.clientWidth, behavior: 'smooth' });
    });
  })();

})();